<template>
  <div>
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>
    <div
      class="stepcontent"
      :class="{
        isstepitem3: fiveselect3,
        isstepitem4: fiveselect4,
        isstepitem5: fiveselect5,
      }"
    >
      <div
        class="stepitem"
        v-for="(item, index) in progressbartitle"
        :key="index"
        :class="{ steptwo: !(index <= isActive) }"
      >
        <span>{{ index + 1 }}{{ item }}</span>
      </div>
    </div>
    <div class="konghuang"></div>
    <transition name="fade-transform">
      <keep-alive :include="keepdata">
        <component
          ref="childrenref"
          :is="coms"
          :cutcoms="cutcoms"
          @sendmdoe="changetestmode"
          :reducesum="reducesum"
          :testname="testname"
          @setExamPage="setExamPage"
          @setExamValue="setExamValue"
          @setSoftApp="setSoftApp"
        ></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keepdata: [
        "Pageone",
        "Smartpagetwo",
        "Pagethree",
        "Pagefour",
        "Combinpagetwo",
        "weightRange",
        "Accuratepagetwo",
      ], //需要加载缓存的组件，默认全部缓存./
      yuanshidata: "", //组卷的原始数据。
      isActive: 0,
      softAppdata: "", //随意改的.暂时先用别的。
      testname: "", //考试名称
      testmode: "", //组卷模式
      pagetwodata: "", //智能组卷第二页的数据 过渡给第三页的数据
      pagetworeq1: "", //智能组卷第二页最终发送并组卷的数据 SelectedApp
      pagetworeq2: "", //智能组卷第二页最终发送并组卷的数据
      pagetworeq3: "", //智能组卷第二页最终发送并组卷的数据====pagetworeq1的第二种形态CookieApp
      pagetworeq4: "", //智能组卷第二页最终发送并组卷的数据====pagetworeq2的第二种形态
      pagethreeData: "", // 智能组卷第三页数据
      pagethreereq: "", //智能组卷第三页最终发送并组卷的数据
      pagetworeq11: "", //精准组卷第二页最终发送并组卷的数据SelectedApp
      pagetworeq22: "", //精准组卷第二页最终发送并组卷的数据testIDarr
      pagetworeq33: "", //精准组卷第二页最终发送并组卷的数据SelectCpt
      pagetworeq44: "", //精准组卷第二页最终发送并组卷的数据CookieCpt
      examThreereq: "", // 试卷组卷第三页最终发送并组卷的数据
      examPage: [], // 试卷组卷第二页的数据 过渡给第三页的数据
      examPage1: "", // 试卷组卷打第二页最终发送数据
      examPage3: {},
      checkmode: "", //命题方式
      reducesum: "", //考试总分
      PaperStyleArr: "", // 试卷组卷第二步到第三步数据
      // Style: "",
      // TestCount: "",
      G_SlectedTestHt: "", //权重第四步需要的数据
      tempSelectCptArray: "", //权重第四部需要的数据
      qzHTML: "", //权重第四部章节记录。
      pageStyelArr: [], //权重组卷第四步数据
      weightThreereq: "", //权重组卷的第三页最终发送的数据
      softApp: {}, // 这是第四步重要的参数 试卷组卷
      DroitArr: {}, //第三步的Total数据
      progressbartitle: [
        //当这个length等于5的时候，就可以对进度条进行控制了。
        ".创建考试",
        ".出题范围",
        ".题量及分数设置",
        ".考场/考生设置",
      ],
      isnewtestaas: 0, //是否是新增状态下如果是从第二步到第三步的，值为0就刷新，从第四步到第三步的，值为1就不刷新。
    };
  },
  components: {
    Pageone: () => import("./components/pageone.vue"),
    Smartpagetwo: () => import("./components/smartpagetwo.vue"),
    Pagethree: () => import("./components/pagethree.vue"),
    Pagefour: () => import("./components/pagefour.vue"),
    //  TestPagefour: () => import("../../../../onlinetestpaper/pagefour.vue"), //在线练习的第四步
    Combinpagetwo: () => import("./components/combinpagetwo.vue"),
    weightRange: () => import("./components/weightRange.vue"), // 权重范围
    Accuratepagetwo: () => import("./components/accuratepagetwo.vue"),
    // Pagefour: () => import("./components/pagefour.vue"), // 添加题库
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Pageone";
        case 1:
          return "Smartpagetwo";
        case 2:
          return "Pagethree";
        case 3:
          return "Pagefour";
        case 1.1:
          return "Combinpagetwo";
        case 1.3:
          return "weightRange";
        case 1.2:
          return "Accuratepagetwo";
      }
      return "ss";
    },
    fiveselect3() {
      if (this.progressbartitle.length === 5 && this.isActive == 1.3) {
        return true;
      } else {
        return false;
      }
    },
    fiveselect4() {
      if (this.progressbartitle.length === 5 && this.isActive == 2) {
        return true;
      } else {
        return false;
      }
    },
    fiveselect5() {
      if (this.progressbartitle.length === 5 && this.isActive == 3) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    setExamPage(e) {
      this.examPage = e;
    },
    setSoftApp(e) {
      this.softApp = e;
    },
    setExamValue(e) {
      this.ExamValue = e;
    },
    cutcoms(index) {
      this.isActive = index;
      if (index == 0) {
        if (this.$children[2]) {
          this.$children[2].firstperform = true;
        }
        Object.assign(
          this.$data,
          JSON.parse(JSON.stringify(this.$parent.newtestdata))
        );
        this.keepdata = ["Pageone"];
      } else {
        //暂时采取这种处理办法，其他步骤全部缓存住。
        this.keepdata = [
          "Pageone",
          "Smartpagetwo",
          "Pagethree",
          "Pagefour",
          "Combinpagetwo",
          "weightRange",
          "Accuratepagetwo",
        ];
      }
    },
    back(istype) {
      // console.log(istype);

      if (istype == "success") {
        this.$parent.cutcoms(0);
        this.$destroy();
        // console.log("jinlai?");
        return;
      }
      let confriemdata = this.$confirm(
        "试卷尚未组完，退出后将不保存组卷信息，是否退出?",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (this.$route.query.trainId) {
            // 培训过来的
            this.$router.push({
              path: "manage",
              query: {
                trainId: this.$route.query.trainId,
              },
            });
          } else {
            this.$parent.cutcoms(0);
          }
          localStorage.removeItem("isreload");
          sessionStorage.removeItem("examState");
          this.$destroy();
        })
        .catch(() => {});
      return confriemdata;
    },
    // 试卷组卷
    changetestmode(a, b, c) {
      this.testname = a;
      this.testmode = b;
      this.checkmode = c;
    },
    addweighttest() {
      this.progressbartitle.splice(2, 0, ".范围权重设置");
    },
  },
  created() {
    this.$parent.newtestdata = JSON.parse(JSON.stringify(this.$options.data()));
    if (this.$route.name == "Testpapers") {
      this.progressbartitle = [
        ".创建练习",
        ".出题范围",
        ".题量及分数设置",
        ".考生设置",
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.stepcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #fff;
}
.stepitem {
  height: 45px;
  background-color: #1890ff;
  border-radius: 45px 45px 45px 45px;
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    transform: translate(90px);
    z-index: 20;
    &::before {
      background-color: #1890ff;
    }
  }
  &:nth-child(2) {
    transform: translate(45px);
    z-index: 10;
  }
  &:nth-child(3) {
    //transform: translate(45px);
    z-index: 5;
  }
  &:nth-child(4) {
    transform: translate(-45px);
    z-index: 1;
  }
  &:nth-child(5) {
    transform: translate(-90px);
    z-index: 0.5;
  }
  &::before {
    display: inline-block;
    position: absolute;
    content: "";
    width: 60px;
    height: 60px;
    background-color: rgb(255, 255, 255);
    border-radius: 50% 50%;
    transform: translate(-8px, -7px);
  }
  span {
    display: inline-block;
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    color: #ffffff;
    padding-left: 71px;
    padding-right: 71px;
  }
}
.konghuang {
  height: 24px;
  background-color: #f8f8f8;
}
.steptwo {
  background-color: #eeeeee;
  span {
    color: #bbbbbb !important;
  }
}
.isstepitem3 {
  > :nth-child(3) {
    background-color: #1890ff;
    > span {
      color: rgb(255, 255, 255) !important;
    }
  }
}
.isstepitem4 {
  > :nth-child(4) {
    background-color: #1890ff;
    > span {
      color: rgb(255, 255, 255) !important;
    }
  }
}
.isstepitem5 {
  > :nth-child(5) {
    background-color: #1890ff;
    > span {
      color: rgb(255, 255, 255) !important;
    }
  }
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

/*
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
/*
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
